import accommodationApi from '../../api/accommodation';
import { router } from '../../main';

const state = {
  rideManagerAccommodations: [],
};

const getters = {
  rideManagerAccommodations: state => state.rideManagerAccommodations,
};

const actions = {
  async resetAllRideManagerAccommodationsData({ commit }) {
    commit('setRideManagerAccommodations', []);
  },    

  async fetchRideMangerAccommodations({ rootState, commit }) {
    const { apptoken } = rootState.appauth;
    const response = await accommodationApi.fetchRideMangerAccommodations( apptoken );
    commit('setRideManagerAccommodations', response.data);
  },
  
  goToAllMyRideManagerAccommodation( /* eslint-disable-line no-unused-vars */ _ ) {
    const path = '/ride_manager_attraction';
    router.push( path )
  },
  
};

const mutations = {
  setRideManagerAccommodations: (state, rideManagerAccommodations) => {
    state.rideManagerAccommodations = rideManagerAccommodations;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};

